export default function countUploading(progressEvent) {
  return parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total));
}
